<script setup lang="ts">
interface SceneStatusItem {
  label: string
  value: string | number
}

withDefaults(
  defineProps<{
    title?: string
    subtitle?: string
    badge: string
    items: SceneStatusItem[]
    hint?: string
    actionLabel?: string
    actionVariant?: 'default' | 'subtle' | 'neutral'
    actionDisabled?: boolean
  }>(),
  {
    title: '状态总览',
    subtitle: '快速查看当前交互和结果数量',
    hint: '',
    actionLabel: '',
    actionVariant: 'subtle',
    actionDisabled: false,
  },
)

const emit = defineEmits<{
  (event: 'action'): void
}>()
</script>

<template>
  <details class="panel-section" open>
    <summary class="panel-section-summary">
      <span class="summary-main">
        <span class="panel-section-title">{{ title }}</span>
        <span class="panel-section-subtitle">{{ subtitle }}</span>
      </span>
      <span class="summary-side">
        <span class="summary-count">{{ badge }}</span>
        <span class="summary-chevron" aria-hidden="true">›</span>
      </span>
    </summary>

    <div class="panel-section-body">
      <div class="status-grid">
        <div v-for="item in items" :key="item.label" class="status-item">
          <span class="status-label">{{ item.label }}</span>
          <strong class="status-value">{{ item.value }}</strong>
        </div>
      </div>

      <p v-if="hint" class="panel-hint">{{ hint }}</p>

      <button
        v-if="actionLabel"
        class="panel-button panel-button-wide"
        :class="{
          'panel-button-subtle': actionVariant === 'subtle',
          'panel-button-neutral': actionVariant === 'neutral',
        }"
        :disabled="actionDisabled"
        @click="emit('action')"
      >
        {{ actionLabel }}
      </button>
    </div>
  </details>
</template>
